import {CLOSE_NOTIFICATION, ERR, SET_CSRF_TOKEN, SHOW_NOTIFICATION} from "./actionTypes";

const initialState = {
  notification: {
    show: false
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CSRF_TOKEN:
      return {
        csrfToken: action.token
      };
    case SHOW_NOTIFICATION:
      return {
        ...state,
        notification: {
          show: true,
          message: action.message,
          color: action.color
        }
      };
    case ERR:
      return {
        ...state,
        notification: {
          show: true,
          message: action.message,
          color: action.err ? 'danger' : 'warning'
        }
      };
    case CLOSE_NOTIFICATION:
      return {
        ...state,
        notification: {
          show: false
        }
      };
    default: return state;
  }
};


// WEBPACK FOOTER //
// ./src/store/appReducer.js